<ion-header>
  <ion-toolbar>
    <ion-title slot="start">Open existing saved boards</ion-title>
    <ion-buttons slot="end">
      <ion-button  class="normal" (click)='cancel()'>Dismiss</ion-button>

    </ion-buttons>
  </ion-toolbar>

 
</ion-header>
<ion-content>

  <div class="body body-container">




    <ion-item class="normal">
      <ion-button *ngIf='!newDoc' class="normal white-text" (click)='newDoc=true'>Switch to->New from template
      </ion-button>
      <!--   
     <ion-button *ngIf='newDoc' class="normal white-text" (click)='newDoc=false'>Switch to->Existing Composition/Preset
      </ion-button>
      -->
 
    </ion-item>

    <ion-list *ngIf='!newDoc'>



      <ion-item class='head-band'>
        <ion-label>
          Existing boards and compositions
        </ion-label>
      </ion-item>
      <ion-card class="card ion-padding-start"  
        *ngFor='let item of getFunBoardList()' >
        <img style="height:100px;width:auto" [src]="itemImage(item)" />
        <ion-card-header><ion-card-title>{{item.title}} </ion-card-title>  </ion-card-header>
        <ion-card-content>
        {{item.description}}
        <ion-label *ngIf="item.contentLink"><a taregt="_blank" [href]="item.contentLink">Info</a></ion-label>
      <ion-button (click)='open(item)'>Open this</ion-button> 
        </ion-card-content>
        <ion-card-footer>
          <ion-label>Tags</ion-label>
            <ion-chip *ngFor="let chip of item.Tags">{{chip}}</ion-chip>

       </ion-card-footer>
    </ion-card>
<!--
<ion-item class='normal ' color="dark" *ngFor='let item of getFunBoardList()' (click)='open(item)'>
        <h2>{{ item.title }}</h2>
      </ion-item>
-->
      

    </ion-list>
  <!-- 



    <ion-list *ngIf='newDoc'>

      <ion-item class='head-band'>
        <ion-label>
          New composition from template
        </ion-label>
      </ion-item>
      <ion-item class="normal" *ngFor='let item of templates' (click)='createFromTemplate(item)'>
        <span> Template: {{ item.title }}</span>
      </ion-item>

    </ion-list>
  -->

</div>
</ion-content>